import { BillsTableColumnsIntl } from 'types/i18n';

export const billsTableColumnsDictionaryRu: BillsTableColumnsIntl = {
  id: 'id',
  organization: 'Организация',
  unp: 'УНП (ИНН / TIN)',
  fullName: 'ФИО',
  resident: 'Резидент',
  amount: 'Сумма',
  amountEUR: 'EUR',
  amountRUB: 'RUB',
  status: 'Статус',
  issuedAt: 'Дата списания',

  paidValueText(paid) {
    if (paid) {
      return 'Оплачено';
    }

    return 'Не оплачено';
  },
  residentValueText(resident) {
    if (resident) {
      return 'Да';
    }

    return 'Нет';
  },
};
